/**
 * @param downloadUrl {string}
 * @return {void}
 */
module.exports = function setRoiCalculatorDownloadLink(downloadUrl) {
    document.querySelectorAll('[data-component="roi-calculator-download-link"]').forEach(downloadLink => {
        if (downloadLink instanceof HTMLAnchorElement) {
            downloadLink.href = downloadUrl;
        }
    });
}
